import { RoleRoute, useTrackingState } from '@checkit/react-components';
import { Grid } from '@material-ui/core';
import React from 'react';
import {useLocation} from 'react-router';
import { Switch } from 'react-router-dom';
import { AppRoute, routes } from '../../routes';
import SimpleBreadcrumbs from './SimpleBreadcrumbs';

const appRoutes = routes.map(
  (route: AppRoute, index: number) => {
    return (
      <RoleRoute
        key={index}
        exact={true}
        path={route.path}
        component={route.component}
        permissions={route.permissions}
      />
    );
  });

export const Content = () => {
  useTrackingState().page(useLocation().pathname);
  return (
    <>
      <SimpleBreadcrumbs />

      <Grid item={true} xs={12}>
        <Switch>
          {appRoutes}
        </Switch>
      </Grid>
    </>
  );
};
